// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2PNSq","alert":"SettungsInbox_alert__1Xmt3"};